// キラシール（ORICA へ画像を渡す）（2026-10-21 に app.js から分けた）
import { S } from './state.js';
import { NS } from './config.js';
import { $ } from './util.js';
import type { KiraSession } from './state.js';

// キラシールにする: ORICA のキラシールメーカー（別ドメイン）を新しいタブで開き、キャラだけの透過 PNG（背景・名前なし、1400px）を
// postMessage で直接送る（サーバーは経由しない）。やりとりは storm/kiraseal/bridge.js と同じ:
//   ORICA → { type: 'kiraseal-ready' }（1秒ごと）、こちら → { type: 'charat-kiraseal', image: Blob }、ORICA → { type: 'kiraseal-received' }
// 受け取る側（D:\Project\orica_new\src\kiraseal\handoff.ts）は送り元を https://charat.me（開発中は http://localhost:8080）に限っている
export const ORICA = location.hostname === 'localhost' ? 'http://localhost:5173' : 'https://orica.ameniwa.com';
export const ORICA_LANGS = ['ja', 'en', 'ko', 'es', 'pt', 'id', 'zh', 'zh-tw', 'vi']; // それ以外は英語版を開く
export const KIRA_SIZE = 1400, KIRA_WAIT = 60000;
export function oricaUrl() {
  const lang = document.documentElement.lang || 'ja', l = ORICA_LANGS.indexOf(lang) >= 0 ? lang : 'en';
  return ORICA + (l === 'ja' ? '' : '/' + l) + '/kiraseal?from=charat';
}
export function kiraImage() {
  const copy = S.stageSvg.cloneNode(true) as SVGSVGElement;
  const layer = copy.querySelector('#nameLayer');
  if (layer) layer.remove();
  const bg = copy.querySelector('#lcart_bg');
  if (bg) bg.textContent = '';
  copy.setAttribute('width', KIRA_SIZE);
  copy.setAttribute('height', KIRA_SIZE);
  let source = new XMLSerializer().serializeToString(copy);
  if (source.indexOf('xmlns=') < 0) source = source.replace('<svg', '<svg xmlns="' + NS + '"');
  return new Promise<Blob>((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = KIRA_SIZE;
      canvas.getContext('2d')!.drawImage(img, 0, 0, KIRA_SIZE, KIRA_SIZE);
      canvas.toBlob((blob) => { if (blob) resolve(blob); else reject(new Error('toBlob')); }, 'image/png');
    };
    img.onerror = reject;
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(source);
  });
}
export function kiraSend(s: KiraSession) {
  if (s.blob && s.ready && !s.done && !s.win.closed) s.win.postMessage({ type: 'charat-kiraseal', image: s.blob }, ORICA);
}
export function openKiraseal() {
  const btn = $('finishKira');
  $('finishError').textContent = '';
  // ポップアップを止められないよう、押した処理の中で先にタブを開く（画像はそのあと作る）
  const win = window.open(oricaUrl(), '_blank');
  if (!win) { $('finishError').textContent = btn.dataset.blocked!; return; }
  const s: KiraSession = S.kiraSession = { win: win, blob: null, ready: false, done: false };
  kiraImage().then((blob) => { s.blob = blob; kiraSend(s); }, () => {
    if (S.kiraSession === s) S.kiraSession = null;
    $('finishError').textContent = btn.dataset.error!;
  });
  setTimeout(() => { if (S.kiraSession === s) S.kiraSession = null; }, KIRA_WAIT);
}
window.addEventListener('message', (e) => {
  const s = S.kiraSession;
  if (!s || e.source !== s.win || e.origin !== ORICA) return;
  if (e.data && e.data.type === 'kiraseal-ready') { s.ready = true; kiraSend(s); }
  else if (e.data && e.data.type === 'kiraseal-received') { s.done = true; S.kiraSession = null; }
});
